import React from 'react';
import OTButtonGroup from '../../tag/OTButtonGroup';
import OTIcon from '../../tag/OTIcon';
import OTButton from '../../tag/OTButton';

export default ({ onClick }) => {
  return (
    <OTButtonGroup type={'big'} expectedCount={1} collapseOnMobile>
      <OTButton className={'ot-button--light'} onClick={onClick}>
        Tulosta{' '}
        <OTIcon config={{ type: 'fa', name: 'fa-print', color: 'white' }} />
      </OTButton>
    </OTButtonGroup>
  );
};
